import { EMAIL_ITEM_ID_KEY } from '../../Email'

export const REQUEST_PROFILE_TAB_EMAILS_THREAD_QUERY_PARAM_KEY =
  'email_thread_uuid'

export const REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PARAM_KEY = 'audience'

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_ALL = 'all'

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_PROVIDERS = 'providers'

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_DWELLERS = 'dwellers'

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_OTHERS = 'others'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_ALL = 'all'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_INBOX = 'inbox'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_SENT = 'sent'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_IMPORTANT = 'important'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_ARCHIVED = 'archived'

export const REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_DWELLERS = 'dwellers'

export const REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_OTHERS = 'managers'

export const REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PROVIDERS = 'providers'

export const REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_BY_CONTACT_TYPE = {
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_ALL]: null,
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_DWELLERS]:
    REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_DWELLERS,
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_OTHERS]:
    REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_OTHERS,
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_PROVIDERS]:
    REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PROVIDERS,
}

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_BY_AUDIENCE = {
  [REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_DWELLERS]:
    REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_DWELLERS,
  [REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_OTHERS]:
    REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_OTHERS,
  [REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PROVIDERS]:
    REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_PROVIDERS,
}

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_TITLE_KEY = {
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_ALL]:
    'RequestProfileTabEmails.AudienceAllKey',
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_DWELLERS]:
    'RequestProfileTabEmails.AudienceDwellersKey',
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_OTHERS]:
    'RequestProfileTabEmails.AudienceOthersKey',
  [REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_PROVIDERS]:
    'RequestProfileTabEmails.AudienceProvidersKey',
}

export const REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_CONTACT_TYPE_KEY = 'contactType'

export const REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_FOLDER_KEY = 'folder'

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_TITLE_KEY = {
  [REQUEST_PROFILE_TAB_EMAILS_FOLDER_ALL]:
    'RequestProfileTabEmails.FolderAllKey',
  [REQUEST_PROFILE_TAB_EMAILS_FOLDER_ARCHIVED]:
    'RequestProfileTabEmails.FolderArchivedKey',
  [REQUEST_PROFILE_TAB_EMAILS_FOLDER_IMPORTANT]:
    'RequestProfileTabEmails.FolderImportantKey',
  [REQUEST_PROFILE_TAB_EMAILS_FOLDER_INBOX]:
    'RequestProfileTabEmails.FolderInboxKey',
  [REQUEST_PROFILE_TAB_EMAILS_FOLDER_SENT]:
    'RequestProfileTabEmails.FolderSentKey',
}

export const REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_ORDER = [
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_ALL,
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_PROVIDERS,
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_DWELLERS,
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_OTHERS,
]

export const REQUEST_PROFILE_TAB_EMAILS_FOLDER_ORDER = [
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_ALL,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_INBOX,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_SENT,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_IMPORTANT,
]

export const REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE = 'audience'

export const REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_SUB_MENU = 'sub_menu'

export const REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_SEARCH = 'search_query'

export const REQUEST_PROFILE_TAB_EMAILS_PERMANENT_FILTERS = [
  REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE,
  REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_SUB_MENU,
]

export const REQUEST_PROFILE_TAB_EMAILS_FILTER_STATE_SUB = 'all'

export const REQUEST_PROFILE_TAB_EMAILS_SEARCH_TIMEOUT = 300

export const REQUEST_PROFILE_TAB_EMAILS_STATE_KEYS = {
  EmptyStateKey: 'RequestProfile.TabEmailsEmptyStateKey',
  ErrorStateKey: 'RequestProfile.TabEmailsErrorStateKey',
  SearchEmptyStateKey: 'RequestProfile.TabEmailsSearchEmptyStateKey',
}

export const REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION = {
  AddNote: 'request_thread_add_note',
  AttachToActivity: 'request_thread_attach_to_activity',
  Delete: 'request_thread_delete_item',
  MarkAsRead: 'request_thread_mark_as_read',
  MarkAsStarred: 'request_thread_mark_as_starred',
  MarkAsUnread: 'request_thread_mark_as_unread',
  MarkAsUnstarred: 'request_thread_mark_as_unstarred',
  MoveToAnotherServiceRequest: 'request_thread_move_to_another_service_request',
  MoveToTab: 'request_thread_move_to_tab',
  OpenInNewTab: 'request_thread_open_in_new_tab',
  Print: 'request_thread_print',
}

export const REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION = {
  AddNote: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AddNote,
  AttachToActivity: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AttachToActivity,
  Delete: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Delete,
  DownloadFiles: 'request_thread_header_download_files',
  MarkAsUnread: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnread,
  MoveToAnotherServiceRequest:
    REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToAnotherServiceRequest,
  MoveToTab: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToTab,
  Print: 'request_thread_header_print',
  ToggleStarred: 'request_thread_header_toggle_starred',
}

export const REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION = {
  Delete: 'request_thread_delete_mass',
  MarkAsRead: 'request_thread_mark_as_read_mass',
  MarkAsStarred: 'request_thread_mark_as_starred_mass',
  MarkAsUnread: 'request_thread_mark_as_unread_mass',
  MarkAsUnstarred: 'request_thread_mark_as_unstarred_mass',
}

// Below this width the emails table + widgets column leave no room for the
// thread preview panel.
export const REQUEST_PROFILE_TAB_EMAILS_PREVIEW_VIEW_MIN_SCREEN_WIDTH = 1200

export const REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTIONS_CLOSING_ACTIVE_PREVIEW = [
  REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Delete,
  REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnread,
  REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToAnotherServiceRequest,
  REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToTab,
]

export const REQUEST_PROFILE_TAB_EMAILS_MASS_ACTIONS_CLOSING_ACTIVE_PREVIEW = [
  REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete,
  REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnread,
]

export const REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION_NAMES = {
  [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete]: 'delete',
  [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsRead]: 'mark_as_read',
  [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsStarred]: 'mark_as_starred',
  [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnread]: 'mark_as_unread',
  [REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnstarred]:
    'mark_as_not_starred',
}

export const REQUEST_PROFILE_TAB_EMAILS_SELECTION_CONFIG = {
  itemIdKey: EMAIL_ITEM_ID_KEY,
}
